var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('body',[_c('div',{ref:"target",staticClass:"collect-container"},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"heading"}},[_c('h1',{staticStyle:{"z-index":"999"}},[_vm._v("FUTURE VISION LAB")])])
}]

export { render, staticRenderFns }